import * as ActionTypes from "./ActionTypes";

export const BOOKING = (
  state = {
    bookingarray: [],
    newBooking: null,
    journeydetails: null,
    email: '', mobilenumber: ''
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_BOOKING_BYROUTE:
      return { ...state, bookingarray: action.payload };
    case ActionTypes.ADD_NEW_BOOKING:
      return { ...state, newBooking: action.payload }

    case ActionTypes.REMOVE_SEATS:
      return { ...state, newBooking: { ...state.newBooking, seats: action.payload } }

    case ActionTypes.ADD_NEW_SEAT_TO_ARRAY:
      const newseat = [action.payload]
      console.log(newseat)
      const x = state.newBooking.seats.concat(newseat)
      console.log("x", x)

      return { ...state, newBooking: { ...state.newBooking, seats: x } }

    case ActionTypes.ADD_BOARDING_POINT:
      return {
        ...state,
        newBooking: { ...state.newBooking, boardingPoint: action.payload },
      };
    case ActionTypes.ADD_DROPPING_POINT:
      return {
        ...state,
        newBooking: { ...state.newBooking, droppingPoint: action.payload },
      };
    case ActionTypes.ADD_JOURNEY_DETAILS_BOOKING:
      return { ...state, journeydetails: action.payload };

    case ActionTypes.CLEAR_BOOKING_STATE:
      return { ...state, newBooking: null }
    case ActionTypes.UPDATE_SEAT_WITH_PERSON_DETAILS:
      return { ...state, newBooking: { ...state.newBooking, seats: action.payload } }

    case ActionTypes.ADD_EMAIL_MOBILE:
      console.log("Inside Action", action.payload.email)
      return { ...state, email: action.payload.email, mobilenumber: action.payload.mobile }

    default:
      return state;
  }
};
